import React from 'react';

import _ from 'lodash';

import InputTextField from '../Fields/InputTextField';

import './AlertConfigurationTableRow.scss';


class AlertConfigurationTableRow extends React.Component {
  _onRecipientInputChange(ident) {
    return value => {
      const alertConfiguration = _.cloneDeep(this.props.data.alertConfiguration);

      // Adding a new recipient
      if (ident === null) {
        alertConfiguration.fields.emails.value.push(value);
      }
      // Updating an existing recipient
      else {
        alertConfiguration.fields.emails.value[ident] = value;
      }

      this.props.onAlertConfigurationChange(alertConfiguration);
    };
  }


  deleteRecipient(ident) {
    const alertConfiguration = _.cloneDeep(this.props.data.alertConfiguration);
    alertConfiguration.fields.emails.value.splice(ident, 1);

    this.props.onAlertConfigurationChange(alertConfiguration);
  }


  _handleDeleteRecipientClick(ident) {
    return () => {
      this.deleteRecipient(ident);
    };
  }


  handleAddRecipientClick = () => {
    this._onRecipientInputChange(null)(null);
  }


  render() {
    const {
      data,
      inputId,
      editMode
    } = this.props;

    const alertRecipientRows = data.alertConfiguration.fields.emails.value.map((email, index) => {
      return { ident: index, data: email };
    });

    const alertTypeValueFormattedForInputId = data.alertTypeValue.toLowerCase().replaceAll('_', '-');

    return (
      <div className="parkchirp--alert-configuration-table-row">
        <div className={`parkchirp--alert-configuration-table--cell` +
          ` parkchirp--alert-configuration-table--alert-type-column`}>
          {data.alertTypeLabel}
        </div>
        <div className={`parkchirp--alert-configuration-table--cell` +
          ` parkchirp--alert-configuration-table--alert-recipients-column`}>
          {alertRecipientRows.map(alertRecipientRow => {
            return (
              <div className="parkchirp--alert-configuration-table-row--alert-recipient-cell-row"
                key={alertRecipientRow.ident}>
                <InputTextField inputId={`${inputId}--${alertTypeValueFormattedForInputId}--${alertRecipientRow.ident}--email`}
                  value={alertRecipientRow.data}
                  onChange={this._onRecipientInputChange(alertRecipientRow.ident)}
                  editMode={editMode}
                />
                {(editMode === true) &&
                  <button type="button"
                    className="parkchirp--button-as-link parkchirp--alert-configuration-table-row--alert-recipient-action"
                    onClick={this._handleDeleteRecipientClick(alertRecipientRow.ident)}>
                    Delete
                  </button>
                }
              </div>
            );
          })}
          {(editMode === true) &&
            <div className="parkchirp--alert-configuration-table-row--alert-recipient-cell-row">
              <button type="button"
                className="parkchirp--button-as-link"
                onClick={this.handleAddRecipientClick}>
                Add Recipient
              </button>
            </div>
          }
        </div>
      </div>
    );
  }
}
export default AlertConfigurationTableRow;
